module.exports = __webpack_public_path__ + "static/media/ui-dropdown.c2c32a20.svg";